var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{staticClass:"px-xs-1 px-sm-0",attrs:{"items":_vm.itemsBreadcrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.href,"disabled":item.disabled,"active-class":"lastBc"}},[_vm._v(" "+_vm._s(item.text.toUpperCase())+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }